/*
 * portalTemplate Actions
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 02-Nov-2022
 */

import { createRequestTypes, createAction, MakeRequest } from './index';

export const actionTypes = {
	DO_ENABLE_WITH_NAVIGATION: '@@portalTemplate/enable_with_navigation',
	DO_SHOW_FOOTER: '@@portalTemplate/show_footer',
	DO_SET_PAGE_TITLE: '@@portalTemplate/set_page_title',
	DO_SET_GO_BACK_LABEL: '@@portalTemplate/set_go_back_label',
	DO_SET_GO_BACK_ROUTE: '@@portalTemplate/set_go_back_route',
	DO_RESET_STATE: '@@portalTemplate/reset_state',
	DO_SET_CUSTOM_GO_BACK_ON_CLICK: '@@portalTemplate/set_custom_go_back_on_click',
	DO_SET_PAYLOAD: '@@portalTemplate/do_set_payload',
	DO_SET_LOCK: '@@portalTemplate/do_set_lock',
	DO_SET_LOADING: '@@portalTemplate/do_set_loading',
	DO_SET_LIGHT_HEADER: '@@portalTemplate/do_set_light_header',
	DO_SET_HAS_LOGO: '@@portalTemplate/do_set_has_logo',
	// @generator action:type
	// @generator action:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request

/** @action
 * * Insert a description
 * @name SetHasLogo
 * @return {object} - The payload object
 */

export const doSetHasLogo = (payload) => createAction(actionTypes.DO_SET_HAS_LOGO, { payload });
/** @action
 * * Insert a description
 * @name SetLightHeader
 * @return {object} - The payload object
 */

export const doSetLightHeader = (payload) => createAction(actionTypes.DO_SET_LIGHT_HEADER, { payload });
/** @action
 * * Insert a description
 * @name EnableWithNavigation
 * @return {object} - The payload object
 */
export const doEnableWithNavigation = (payload) => createAction(actionTypes.DO_ENABLE_WITH_NAVIGATION, { payload });

/** @action
 * * Insert a description
 * @name ShowFooter
 * @return {object} - The payload object
 */
export const doShowFooter = (payload) => createAction(actionTypes.DO_SHOW_FOOTER, { payload });

/** @action
 * * Insert a description
 * @name SetPageTitle
 * @return {object} - The payload object
 */
export const doSetPageTitle = (payload) => createAction(actionTypes.DO_SET_PAGE_TITLE, { payload });

/** @action
 * * Insert a description
 * @name SetGoBackLabel
 * @return {object} - The payload object
 */
export const doSetGoBackLabel = (payload) => createAction(actionTypes.DO_SET_GO_BACK_LABEL, { payload });

/** @action
 * * Insert a description
 * @name SetGoBackRoute
 * @return {object} - The payload object
 */
export const doSetGoBackRoute = (payload) => createAction(actionTypes.DO_SET_GO_BACK_ROUTE, { payload });

/** @action
 * * Insert a description
 * @name ResetState
 * @return {object} - The payload object
 */
export const doResetState = (payload) => createAction(actionTypes.DO_RESET_STATE, { payload });

/** @action
 * * Insert a description
 * @name SetCustomGoBackOnClick
 * @return {object} - The payload object
 */
export const doSetCustomGoBackOnClick = (payload) =>
	createAction(actionTypes.DO_SET_CUSTOM_GO_BACK_ON_CLICK, { payload });

/** @action
 * * Insert a description
 * @name SetLock
 * @return {object} - The payload object
 */
export const doSetLock = (payload) => createAction(actionTypes.DO_SET_LOCK, { payload });

/** @action
 * * Insert a description
 * @name SetLoading
 * @return {object} - The payload object
 */
export const doSetLoading = (payload) => createAction(actionTypes.DO_SET_LOADING, { payload });

// @generator action
